export default "/images/press1.jpg?6a8ce5694ee5c60f277916e5c7d8ed06";